import React from "react";
import { formatDateAndTimeWithoutLocal, formateDateAndTime, formateDateWithTime } from "../../../utils/commonFunctions";
import { CalenderGreenIcon, CheckCircleGreen, PendingIcon, locationIcon } from "../../../assets/images";

type AppProps={
    item:any;
    handleEditMeetUp:(id:number)=>void;
}

const ClientMeetUpCard = ({item,handleEditMeetUp}: AppProps) => {
  return (
    <div
      className="single_container"
      onClick={() => handleEditMeetUp(item?.client_code)}
    >
     {item?.meeting_time ? <div className="date mt-2">
       <img src={CalenderGreenIcon} alt="calender" /> { formatDateAndTimeWithoutLocal(item?.meeting_time) }
      </div> : ""}

      <div className="client_name mt-2">
        {item?.name}
        <span className="client_code"> {`CC- ${item?.client_code}`}</span>
      </div>

      <div className="mt-2">
        {" "}
        <span className="mr-1">
          <img src={locationIcon} />
        </span>{" "}
       {item?.city} {item?.city ? "," : ""} {item?.state} {item?.state ? "," : ""} {item?.country}
      </div>

      <div className={`mt-3  ml-1  ${item?.meet_up_completed ? "completed" : "pending"  }`}>
        <span className="mr-2">
          <img src={item?.meet_up_completed ? CheckCircleGreen : PendingIcon} alt="check" />
        </span>
        {item?.meet_up_completed ?  "Completed" : "Pending" } Checklist
      </div>
    </div>
  );
};

export default ClientMeetUpCard;
